var _circle, _rect, _g, _rect2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCopyMypage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FF6262"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2046_21057",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 3,
    width: 7,
    height: 7
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.1782,
    y: 3.1526,
    width: 3.89736,
    height: 5.65887,
    rx: 1.94868,
    transform: "rotate(45 10.1782 3.1526)",
    stroke: "black",
    strokeWidth: 0.8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2046_21057)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9043 6.06596L10.8013 1.96289L7.37594 5.38822L11.479 9.4913L14.9043 6.06596ZM11.4787 9.49162L9.03638 7.04932L7.27181 8.81388L9.71412 11.2562L11.4787 9.49162Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2046_21057",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 7,
    height: 7
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.02588,
    y: 12.8162,
    width: 3.89736,
    height: 5.65887,
    rx: 1.94868,
    transform: "rotate(-135 6.02588 12.8162)",
    stroke: "black",
    strokeWidth: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2046_21057)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29878 9.90181L5.40186 14.0049L8.82719 10.5796L4.72412 6.47648L1.29878 9.90181ZM4.7244 6.4762L7.1667 8.91851L8.93126 7.15394L6.48896 4.71164L4.7244 6.4762Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopyMypage);
export default __webpack_public_path__ + "static/media/ic_copy_mypage.28628535cfc1a0a661d8568ef2242a96.svg";
export { ForwardRef as ReactComponent };